import React from 'react'
import ReactDOM from 'react-dom'
import 'semantic-ui-css/semantic.min.css'

import Application from '../src/application'
import registerServiceWorker from './registerServiceWorker'

ReactDOM.render(<Application />, document.getElementById('root'))
registerServiceWorker()
